import React from 'react';
import { InputButton } from './InputButton';

interface SubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <InputButton
      type="submit"
      dataTestId="submit-button"
      variant="primary"
      disabled={disabled}
      icon={
        <svg
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
          />
        </svg>
      }
      onClick={onClick}
    />
  );
};
